import { ROUTES } from '@/config/routes';
import { WORKSPACE_NAV, type WorkspaceNavItem } from '@/config/workspace-nav';
import { useAuthStore } from '@/stores/auth';

/** 세션 기능 목록에 있는 메뉴만 — 메뉴 노출의 단일 판단 지점(specs/064 FR-011). */
export function useWorkspaceNav(): readonly WorkspaceNavItem[] {
  const features = useAuthStore((s) => s.features);
  return WORKSPACE_NAV.filter((item) => features.includes(item.feature));
}

/**
 * 로고·브레드크럼 "워크스페이스" 링크 — 할 일(TASKS)이 있으면 기존대로 할 일, 없으면 첫 허용 메뉴(기업 회원 = 홈, specs/065).
 * 축이 아니라 기능 유무로 정한다.
 */
export function useWorkspaceHomeLink(): string {
  const nav = useWorkspaceNav();
  const hasTasks = nav.some((item) => item.feature === 'TASKS');
  return hasTasks ? ROUTES.workspace.dashboard : (nav[0]?.to ?? ROUTES.workspace.root);
}
